import { Grid } from "@material-ui/core";
import TeamAreaRow, { BattleResultMemberType } from "./TeamAreaRow";

export type BattleResultTeamType = {
    front: BattleResultMemberType;
    middle: BattleResultMemberType;
    back: BattleResultMemberType;
}

type Props = BattleResultTeamType

const TeamArea = ({ front, middle, back }: Props) => {
    return (
        <Grid item style={{ height: '90%', margin: "10px" }}>
            <div style={{ display: "flex", float: "left" }}>
                <TeamAreaRow position="FRONT" {...front} />
                <TeamAreaRow position="MIDDLE" {...middle} />
                <TeamAreaRow position="BACK" {...back} />
            </div>
        </Grid>
    );
}

export default TeamArea;